import { Button, message } from "antd";
import SmallCardWrapper from "./SmallCardWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  PrintInvoiceThunk,
  PrintLabelThunk,
} from "../../store/thunks/orderThunk";
import { resetInvoice, resetLabel } from "../../store/slices/orderSlice";

export const PrintInvoice = ({ orderRefId, shippingData, overview }) => {
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.printInvoice);
  const { data: label } = useSelector((state) => state.printLabel);

  useEffect(() => {
    data?.invoiceUrl &&
      window.open(data?.invoiceUrl, "_blank", "noopener,noreferrer");
    dispatch(resetInvoice());
  }, [data?.invoiceUrl]);

  useEffect(() => {
    const pdfContent = label?.pdfContent;
    if (label) {
      if (pdfContent) {
        // Convert base64 to a downloadable PDF Blob
        const byteCharacters = atob(pdfContent);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "shipping-label.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else if (label?.label_url) {
        // Fallback to opening the label_url in new tab
        window.open(label?.label_url, "_blank", "noopener,noreferrer");
      } else {
        message.error("No PDF content or label URL found.");
      }
      dispatch(resetLabel());
    }
  }, [label?.label_url]);

  return (
    <SmallCardWrapper name={"Invoice"}>
      <div className="text-center my-5">
        <Button
          className="btn btn-dark font-weight-bold letter-spacing btn-md"
          onClick={() => {
            dispatch(
              PrintInvoiceThunk({
                id: orderRefId,
              }),
            );
          }}
        >
          Print Invoice
        </Button>
        {shippingData?.shippingInformation?.deliveryMode === "EXTERNAL" &&
          shippingData?.shippingInformation?.orderStatus !==
            "SHIPMENT_CANCELLED" &&
          overview?.orderStatus !== "CANCELLED" && (
            <Button
              className="btn btn-dark font-weight-bold letter-spacing btn-md ml-3"
              onClick={() => {
                dispatch(
                  PrintLabelThunk({
                    shipmentId: shippingData?.shippingInformation
                      ?.shipRockedShipmentId
                      ? shippingData?.shippingInformation?.shipRockedShipmentId
                      : shippingData?.shippingInformation?.prozoAwbNumber
                        ? shippingData?.shippingInformation?.prozoAwbNumber
                        : shippingData?.shippingInformation
                            ?.courierPartnerShipmentId,
                    shippingPartner:
                      shippingData?.shippingInformation?.shipmentProvider,
                  }),
                );
              }}
            >
              Download Label
            </Button>
          )}
      </div>
    </SmallCardWrapper>
  );
};
